import { AnalystData, AnalystDataType } from './resume_interfaces';

export class PieCharData {
  labels: string[] = [];
  data: number[] = [];
  notData: boolean = false;
  colors: string[] = [];
  constructor(data: AnalystData[]) {
    data.forEach((item: AnalystData) => {
      this.labels.push(item._id?.fullname || 'Sin asignar');
      this.data.push(item.amount);
      this.colors.push(item.color);
    });
    if (data.length == 0) {
      this.labels = ['No hay datos'];
      this.data = [1];
      this.notData = true;
    } else {
      this.notData = false;
    }
  }
}

export class PieCharDataAlert {
  labels: string[] = [];
  data: number[] = [];
  notData: boolean = false;
  colors: string[] = [];
  constructor(data: AnalystData[]) {
    data.forEach((item: AnalystDataType) => {
      this.labels.push(item._id.type || 'Sin tipo');
      this.data.push(item.amount);
      this.colors.push(item.color);
    });
    if (data.length == 0) {
      this.labels = ['No hay datos'];
      this.data = [1];
      this.notData = true;
    } else {
      this.notData = false;
    }
  }
}
